import gql from "graphql-tag.macro";

const gqlUpdateSysChainDocumentBuilder = gql`
    mutation updateSysChainDocumentBuild(
        $systemChainInput: [systemChainInput!]!
    ) {
        updateSysChainDocumentBuild(chains: $systemChainInput) {
            syschains {
                documentBuilder {
                    id
                    name
                    description
                    feature
                    textPrompt
                    promptNodes
                    model
                    temperature
                }
            }
        }
    }
`;

const gqlSysConfig = gql`
    query {
        sysconfig {
            syschains {
                documentBuilder {
                    id
                    name
                    description
                    feature
                    textPrompt
                    action
                    promptNodes
                    model
                    temperature
                }
            }
            envchains {
                feature
                name
                promptNodes
            }
        }
    }
`;

const gqlUpdateEnvChains = gql`
    mutation updateEnvChains($chains: [envChainsInput!]!) {
        envChainsUpdated(chains: $chains) {
            feature
            name
            promptNodes
        }
    }
`;

export const loadSysConfig = async ({ client }) => {
  const {
    data: { sysconfig },
  } = await client.query({
    query: gqlSysConfig,
    fetchPolicy: "no-cache",
  });

  sysconfig?.syschains?.documentBuilder?.forEach(chain => {
    for (const key in chain) {
      if (chain[key] === null) {
        delete chain[key];
      }
    }
    delete chain["__typename"];
  });

  sysconfig?.envchains?.forEach(chain => {
    for (const key in chain) {
      if (chain[key] === null) {
        delete chain[key];
      }
    }
    delete chain["__typename"];
  });
  return sysconfig;
};

export const updateSysChainDocumentBuilder = async ({ chains }, { client }) => {
  try {
    await client.mutate({
      mutation: gqlUpdateSysChainDocumentBuilder,
      variables: { systemChainInput: chains },
    });

    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const updateEnvChains = async ({ chains }, { client }) => {
  try {
    await client.mutate({
      mutation: gqlUpdateEnvChains,
      variables: { chains: chains || []},
    });

    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};
